//

import USER_TYPE from '../constants/user-type';

// Exports
// -------

export default function isEmployee(userType) {
  return userType === USER_TYPE.employee;
}
